import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  root: ({ preferred, all, hasPreferredCountries }) => ({
    top: '18px',
    '& input[type="tel"]': {
      display: 'none',
    },
    '& .flag-dropdown': {
      border: 'none !important',
    },
    '& .selected-flag': {
      border: 'none',
      background: 'none',
    },
    '& + div input': {
      marginLeft: 45,
    },
    '& .country-list > div': {
      marginTop: `${hasPreferredCountries ? '40px' : '0px'}`,
    },
    '& .preferred:first-of-type': {
      height: '80px !important',
      marginTop: '-40px',
      '&:before': {
        content: `'${preferred}'`,
        display: 'block',
        fontWeight: 'bold',
        padding: '5px 10px 10px',
        margin: '-5px -10px 5px',
        backgroundColor: '#fff',
      },
    },
    '& div[data-country-code="af"]:not(.preferred:first-child)': {
      height: '80px !important',
      '&:before': {
        content: `'${all}'`,
        display: 'block',
        fontWeight: 'bold',
        padding: '5px 10px 10px',
        margin: '-5px -10px 5px',
        backgroundColor: '#fff',
      },
      '& ~ div': {
        marginTop: '40px',
      },
    },
  }),
});
